import "../sass/style.scss";

const mobFilters = document.querySelector(".mobile-filters__menu-btn");
const filtersMenu = document.querySelector(".sidebar-filters");
const closeMobFilters = filtersMenu.querySelector(".mobile-close");

// check if mobFilters exists and then add event listener for click and touch events
if (mobFilters) {
  mobFilters.addEventListener("click", () => {
    filtersMenu.classList.toggle("mobile-visible");
  });
  mobFilters.addEventListener("touchstart", () => {
    filtersMenu.classList.toggle("mobile-visible");
  });
}

// check if closeMobFilters exists and then add event listener for click and touch events
if (closeMobFilters) {
  closeMobFilters.addEventListener("click", () => {
    filtersMenu.classList.remove("mobile-visible");
  });
  closeMobFilters.addEventListener("touchstart", () => {
    filtersMenu.classList.remove("mobile-visible");
  });
}

// scan sidebar filter and add tiles to mobile filter bar when checked
const categories = filtersMenu.querySelectorAll(".post-types ul li input");
const tags = filtersMenu.querySelectorAll(".tags ul li input");

// addFilterTile function. Multiple steps:
// 1. When an input is checked, get the Label text as well as the input value
// 2. Create a new div element and add the class "mobile-filters-active-tile"
// 3. Add the label text to the innerHTML of the new div and add the value attribute from the input to the div
// 4. Append the new div to the mobile filter bar
addFilterTile = (label) => {
  const filterBar = document.querySelector(".mobile-filters-active");
  const filterTile = document.createElement("div");
  filterTile.classList.add("mobile-filters-active-tile");
  const labelText = label.textContent;
  const input = label.querySelector("input");
  filterTile.innerHTML = labelText;
  console.log(label);
  console.log(input.value);
  console.log(labelText);
  filterTile.setAttribute("value", input.value);
  filterBar.appendChild(filterTile);
};

removeFilterTile = (target) => {
  const filterBar = document.querySelector(".mobile-filters-active");
  const filterTiles = filterBar.querySelectorAll(".mobile-filters-active-tile");
  filterTiles.forEach((tile) => {
    if (tile.textContent === target.parentElement.textContent) {
      filterBar.removeChild(tile);
    }
  });
};

// clicking the filter tile will remove it from the mobile filter bar, as well as unchecking the input in the sidebar based on the value attribute
const filterBar = document.querySelector(".mobile-filters-active");
filterBar.addEventListener("click", (e) => {
  if (e.target.classList.contains("mobile-filters-active-tile")) {
    const value = e.target.getAttribute("value");
    // Find the corresponding input
    const input = document.querySelector(`input[value="${value}"]`);
    input.checked = false; // Uncheck the input

    // Dispatch a 'change' event for the input
    input.dispatchEvent(new Event("change"));

    // Remove the tile from the filter bar
    filterBar.removeChild(e.target);
  }
});

// when an input is checked, get the Label text and add it to the mobile filter bar. The label is the parent element of the input
categories.forEach((category) => {
  category.addEventListener("change", (e) => {
    if (e.target.checked) {
      const label = e.target.parentElement;
      console.log(label + " checked");
      addFilterTile(label);
    } else {
      removeFilterTile(e.target);
    }
  });
});

tags.forEach((category) => {
  category.addEventListener("change", (e) => {
    if (e.target.checked) {
      const label = e.target.parentElement;
      console.log(label + " checked");
      addFilterTile(label);
    } else {
      removeFilterTile(e.target);
    }
  });
});

// when any years filter is clicked (or touched on mobile), browser viewport needs to smooth scroll to the top of "all-updates__content" section
const years = document.querySelectorAll(".years-filter .year-link");
const allUpdates = document.querySelector(".all-updates__content");

// check if years and allUpdates exist and then add event listener for click and touch events
if (years && allUpdates) {
  years.forEach((year) => {
    year.addEventListener("click", (e) => {
      e.preventDefault();
      allUpdates.scrollIntoView({ behavior: "smooth" });
    });
    year.addEventListener("touchstart", (e) => {
      e.preventDefault();
      allUpdates.scrollIntoView({ behavior: "smooth" });
    });
  });
}
